import Modal from '../Utils/Modal';
import '../../styles/technicalProblemModal.scss';
import { useIntl } from 'react-intl';
import { ReactComponent as PragmagoLogo } from '../../icons/logo-pragmago.svg';

const TechnicalProblemModal = (props) => {
  const { formatMessage } = useIntl();

  return (
    <Modal extraClass='technicalProblem' {...props}>
      <div className='modal-container'>
        <PragmagoLogo />

        <span className='modal-headline'>
          {formatMessage(
            { id: 'Technical problem headline' },
            {
              br: <br />,
            }
          )}
        </span>

        <span className='modal-description'>
          {formatMessage(
            { id: 'Technical problem description' },
            {
              br: <br />,
            }
          )}
        </span>

        <a className='modal-button' href='https://support.pragmago.tech/' target='_blank' rel='noreferrer'>
          {formatMessage({ id: 'Technical problem button label' })}
        </a>
      </div>
    </Modal>
  );
};

export default TechnicalProblemModal;
